module.exports = __webpack_public_path__ + "static/ethcc2-book-launch-c1e600a986de4cc5c65484f22f666680.jpeg";